import { Component, EventEmitter, Output, OnInit } from "@angular/core";
import { getSelectOverlay } from "@edp-store/selectors/layout.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { SelectOverlayAction } from "@edp-store/actions/layout.actions";
import { environment } from "@edp-environments/environment";

@Component({
    selector: "edp-overlay",
    templateUrl: "./edp-overlay.component.html",
    styleUrls: ["./edp-overlay.component.scss"],
})
export class EdpOverlayComponent implements OnInit {
    @Output()
    public displayLoader = new EventEmitter<boolean>();
    public type: string;
    public origin?: string;

    public showHideSideBar: boolean;
    public overlayStatusChanged: Subject<{ type: string; event: "hide" | "show" }> = new Subject();
    public isApp: boolean;

    constructor(private store: Store<IAppState>) {
        this.store.pipe(select(getSelectOverlay)).subscribe(data => {
            this.showHideSideBar = false;
            if (data && data.type) {
                this.type = data.type;
                this.origin = data.origin;
                this.showHideSideBar = true;
                setTimeout(() => this.overlayStatusChanged.next({ type: this.type, event: "show" }), 0);
            }
        });
    }

    ngOnInit() {
        this.isApp = environment.isApp;
    }

    public close(): void {
        this.showHideSideBar = false;
        this.overlayStatusChanged.next({ type: this.type, event: "hide" });
        this.store.dispatch(new SelectOverlayAction(null));
    }

    public showLoader(event): void {
        this.displayLoader.emit(event);
    }
}
